import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export default function SuspendOrgDialog({ org, onClose, onDone }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await api.post(`/enterprise/organizations/${org.id}/suspend`, { reason }); toast.success(`${org.name} suspended`); setReason(""); onDone(); onClose(); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <Dialog open={!!org} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="org-suspend-dialog">
        <DialogHeader><DialogTitle>Suspend {org?.name}?</DialogTitle>
          <DialogDescription>Staff can no longer open this organization, and patient signing links and reminders stop working. Nothing is deleted; Reactivate brings everything back.</DialogDescription></DialogHeader>
        <Textarea value={reason} maxLength={200} onChange={(e) => setReason(e.target.value)} placeholder="Reason (for example: contract ended, security review)" data-testid="org-suspend-reason" />
        <DialogFooter><Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button className="bg-red-600 hover:bg-red-700 text-white" disabled={!reason.trim() || busy} onClick={go} data-testid="org-suspend-confirm">Suspend organization</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
